import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Lock, ArrowRight } from 'lucide-react';
import axios from 'axios';
import { toast } from 'sonner';
import { useAuth } from '../../contexts/AuthContext';

const API_BASE = process.env.REACT_APP_BACKEND_URL || '';

export default function SubscriptionExpiredBanner() {
  const { user, token } = useAuth();
  const [sub, setSub] = useState(null);

  useEffect(() => {
    if (!user || !token) return;
    axios
      .get(`${API_BASE}/api/me/subscription`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => setSub(res.data))
      .catch(() => setSub(null));
  }, [user, token]);

  // Intercepta 402 e 403 (MODULE_NOT_IN_PLAN) globalmente
  useEffect(() => {
    const interceptor = axios.interceptors.response.use(
      (resp) => resp,
      (error) => {
        const status = error?.response?.status;
        const data = error?.response?.data;
        if (status === 402 && data?.subscription) {
          setSub(data.subscription);
        }
        if (status === 403 && data?.code === 'MODULE_NOT_IN_PLAN') {
          toast.error('Módulo não está no seu plano', {
            description: data.detail || 'Faça upgrade para liberar este módulo.',
            action: { label: 'Ver planos', onClick: () => { window.location.href = '/billing'; } },
          });
        }
        return Promise.reject(error);
      }
    );
    return () => axios.interceptors.response.eject(interceptor);
  }, []);

  if (!sub || !sub.is_expired) return null;

  return (
    <div
      className="bg-gradient-to-r from-rose-600/15 via-rose-500/10 to-rose-600/15 border-b-2 border-rose-500/40 px-4 py-3"
      data-testid="subscription-expired-banner"
    >
      <div className="flex items-center justify-between gap-3 max-w-7xl mx-auto">
        <div className="flex items-center gap-3 min-w-0">
          <div className="flex-shrink-0 w-8 h-8 rounded-lg bg-rose-500/20 border border-rose-500/40 flex items-center justify-center">
            <Lock className="h-4 w-4 text-rose-300" />
          </div>
          <div className="min-w-0">
            <div className="text-rose-100 font-semibold text-sm">
              {sub.status === 'canceled'
                ? 'Sua assinatura foi cancelada.'
                : 'Seu período de teste terminou.'}
            </div>
            <div className="text-rose-200/80 text-xs truncate">
              Você ainda pode visualizar seus dados, mas precisa ativar um plano para criar ou editar.
            </div>
          </div>
        </div>
        <Link
          to="/billing"
          className="flex-shrink-0 inline-flex items-center gap-1.5 px-4 py-2 rounded-lg bg-gradient-to-r from-[#0033FF] to-[#0099FF] hover:from-[#0044FF] hover:to-[#00AAFF] text-white text-sm font-semibold shadow-lg shadow-[#0033FF]/30 transition-all hover:scale-[1.02]"
          data-testid="expired-cta-btn"
        >
          Ativar plano
          <ArrowRight className="h-4 w-4" />
        </Link>
      </div>
    </div>
  );
}
